export enum SliceStatus {
    initial = "initial",
    loading = "loading",
    succeeded = "succeeded",
    failed = "failed",
    idle = "idle"
}
  